export function setCssColors() {
    console.log("set css colors");

    let natureColor = 'linear-gradient(180deg, #58BBAD 0%, #4BA9AF 100%)';
    let cultureColor = 'linear-gradient(180deg, #E8BD55 0%, #D3A140 100%)';
    let sportColor = 'linear-gradient(180deg, #E26E69 0%, #CF5651 100%)';
    let turismColor = 'linear-gradient(180deg, #60729F 0%, #4B5D8A 100%)';

    let natureColorStart = '#58BBAD';
    let natureColorEnd = '#4BA9AF';

    let cultureColorStart = '#E8BD55';
    let cultureColorEnd = '#D3A140';

    let sportColorStart = '#E26E69';
    let sportColorEnd = '#CF5651';

    let turismColorStart = '#60729F';
    let turismColorEnd = '#4B5D8A';

    let natureColorActive = '#2A873E';
    let cultureColorActive = '#9E882F';
    let sportColorActive = '#992E2E';
    let turismColorActive = '#153945';    

    document.documentElement.style.setProperty('--nature-color-gradient', natureColor);
    document.documentElement.style.setProperty('--culture-color-gradient', cultureColor);
    document.documentElement.style.setProperty('--sport-color-gradient', sportColor);
    document.documentElement.style.setProperty('--turism-color-gradient', turismColor);

    document.documentElement.style.setProperty('--nature-color-start', natureColorStart);
    document.documentElement.style.setProperty('--nature-color-stop', natureColorEnd);

    document.documentElement.style.setProperty('--culture-color-start', cultureColorStart);
    document.documentElement.style.setProperty('--culture-color-stop', cultureColorEnd);

    document.documentElement.style.setProperty('--sport-color-start', sportColorStart);
    document.documentElement.style.setProperty('--sport-color-stop', sportColorEnd);

    document.documentElement.style.setProperty('--turism-color-start', turismColorStart);
    document.documentElement.style.setProperty('--turism-color-stop', turismColorEnd);

    document.documentElement.style.setProperty('--nature-color-active', natureColorActive);
    document.documentElement.style.setProperty('--culture-color-active', cultureColorActive);
    document.documentElement.style.setProperty('--sport-color-active', sportColorActive);
    document.documentElement.style.setProperty('--turism-color-active', turismColorActive);
}